module.exports = __webpack_public_path__ + "img/rank-1st.d8971264.png";